import { logger } from '@/utils/logger';
import { videosApi } from '@/api/upload/videos';

export function getCorrectUrl(url: string): string {
  if (!url) return '';



  if (url.includes('-flow.json')) {
    const videoIdMatch = url.match(/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})-flow\.json/);
    if (videoIdMatch && videoIdMatch[1]) {
      const videoId = videoIdMatch[1];
      return `/api/v1/videos/${videoId}/flow-json`;
    }
  }


  if (url.includes('-processed.mp4')) {
    const videoIdMatch = url.match(/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})-processed\.mp4/);
    if (videoIdMatch && videoIdMatch[1]) {
      const videoId = videoIdMatch[1];
      return `processed-video-endpoint:${videoId}`;
    }
  }

  if (url.startsWith('/app/uploads/')) {
    const filename = url.split('/').pop();
    return `/api/v1/uploads/${filename}`;
  }

  if (url.startsWith('/uploads/')) {
    const filename = url.split('/').pop();
    return `/api/v1/uploads/${filename}`;
  }

  if (url.includes('/api/flowtube/uploads/')) {
    const filename = url.split('/').pop();
    return `/api/v1/uploads/${filename}`;
  }

  if (url.includes('/api/v1/uploads/')) {
    return url;
  }

  return url;
}

export function generateFlowVectors(count: number, maxVelocity: number) {
  const vectors = [];
  for (let i = 0; i < count; i++) {
    const x = Math.floor(Math.random() * 100);
    const y = Math.floor(Math.random() * 100);
    const velocity = 0.5 + Math.random() * maxVelocity;
    const angle = Math.floor(Math.random() * 60) + 10;
    vectors.push({ x, y, velocity, angle });
  }
  return vectors;
}

// Interfaces for type safety
interface ToastFunction {
  (options: {
    title?: string;
    description?: string;
    variant?: 'default' | 'destructive';
  }): void;
}

interface SimulationData {
  [key: string]: unknown;
}

export async function downloadReport(
  videoId: string,
  format: string = 'pdf',
  simulationData: SimulationData | null = null,
  toast: ToastFunction,
  openInNewTab: boolean = true
) {
  if (!videoId) {
    toast({
      title: "Error",
      description: "No video selected. Please select a video before downloading a report.",
      variant: "destructive"
    });
    return;
  }

  toast({
    title: "Preparing report",
    description: "Your analysis report is being generated. Please wait...",
  });

  try {
    const response = await videosApi.getAnalysisReport(videoId, format, simulationData);

    if (response?.download_url) {
      const link = document.createElement('a');
      link.href = response.download_url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.download = response.filename || `seapattern_report_${videoId}_${Date.now()}.${format}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast({
        title: "Report opened",
        description: `Your ${format.toUpperCase()} report has been opened in a new tab.`,
      });
    } else {
      logger.error("[downloadReport] No download URL in response:", response);
      throw new Error("No download URL provided in the response");
    }
  } catch (error) {
    logger.error("Error downloading report:", error);
    toast({
      title: "Download failed",
      description: "There was an error generating your report. Please try again.",
      variant: "destructive"
    });
  }
}
